import { HTMLAttributes } from "react";

export const generateTestId = (dataTestId: string) => ({
  component: dataTestId,
});

export interface ToastProps extends HTMLAttributes<HTMLDivElement> {
  status?: keyof typeof statusClasses;
  duration?: number;
  icon?: React.ReactNode;
  message?: string;
  actions?: React.ReactNode;
}

export const statusClasses = {
  info: 'bg-secondary-500 text-white',
  error: 'bg-red-500 text-white',
  success: 'bg-success-500 text-white',
  warning: 'bg-warning-500 text-white',
};
